const SETTINGS = {
    backgroundAudio: `/assets/fitPro/audio/musicloop_fitpro.mp3`, 
    backgroundWelcomeBackScreen: { prop: 'backgroundColor', value: '#83C6A6' }
  }
  
export default SETTINGS